(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-wishlist-page"]) return;
  try {
    
  class WishlistView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.gridViewContainer = this.querySelector('[data-wishlist-items-grid-display]');
      this.wishlistPaginateContainer = document.getElementById('wishlist-paginate');
      this.viewCols = [...this.querySelectorAll('[data-col]')];

      this.wishlistContainer = this.closest('[data-wishlist-container]');
      this.wishlistFooter = document.querySelector('[data-wishlist-footer]');

      this.viewCols.forEach(viewCol => {
        viewCol.addEventListener('click', this.onViewColClick.bind(this));
      });

      window.addEventListener('resize', theme.utils.rafThrottle(this.onResize.bind(this)));

      this.initWishlistPage();
    }

    getMaxColOnSize() {
      const availableViewCols = this.viewCols.filter(view => {
        return getComputedStyle(view, null).getPropertyValue('display') === 'inline-block';
      }).map(view => Number(view.dataset.col));

      return availableViewCols[availableViewCols.length - 1];
    }

    onResize() {
      const selectedColEl = this.querySelector('[data-col].active');
      if (!selectedColEl) return;
      const selectedCol = Number(selectedColEl.dataset.col);
      const maxColNum = this.getMaxColOnSize();

      if (selectedCol > maxColNum) {
        const target = this.viewCols.find(viewCol => Number(viewCol.dataset.col) === maxColNum);
        if (target) target.click();
      }
    }

    onViewColClick(event) {
      const viewCol = event.target;
      const col = Number(viewCol.dataset.col);

      this.switchViewListGrid(col === 1);
      this.setPaginationAndHeadingView(col === 1);
      this.paginationForList(col === 1);
      this.setGridColumns(col);
      this.setActiveViewCol(viewCol);
    }

    switchViewListGrid(isList) {
      if (isList) {
        this.gridViewContainer.classList.add('productList');
        return;
      }

      this.gridViewContainer.classList.remove('productList');
    }

    setGridColumns(col) {
      this.gridViewContainer.style.setProperty('--grid-columns', col);
    }

    setActiveViewCol(colElement) {
      this.viewCols.forEach(col => col.classList.remove('active'));
      colElement.classList.add('active');
    }

    setPaginationAndHeadingView(isList) {
      if (isList) {
        this.wishlistPaginateContainer.style.display = 'flex';
        return;
      }

      this.wishlistPaginateContainer.style.display = 'none';
    }

    paginationForList(isList) {
      const items = this.gridViewContainer.querySelectorAll('.product');
      const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage);

      if (isList && currentPage) {
        items.forEach((item, index) => {
          if (index >= (currentPage - 1) * 3 && index < currentPage * 3) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      } else {
        items.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    async initWishlistPage() {
      if (typeof(Storage) !== 'undefined') {
        const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

        if (wishlistList.length > 0) {
          try {
            await Promise.all(wishlistList.map((handle, index) => this.setProductForWishlistPage(handle, index, wishlistList.length)));
            this.gridViewContainer.classList.add('is-loaded');
            this.wishlistPagination();
            this.setDefaultLayout();

            document.addEventListener('update:pagination', this.wishlistPagination.bind(this));
            document.addEventListener('add:wishlist-item', async (event) => {
              const handle = event.detail.handle;
              await this.setProductForWishlistPage(handle);
            });
            document.addEventListener('remove:wishlist-item', (event) => {
              const handle = event.detail?.handle;
              const productId = event.detail?.productId;
              this.removeItemFromWishlistPage(handle, productId);
            });
          } catch(err) {
            console.error(err);
          }
        } else {
          if (this.wishlistContainer) {
            this.wishlistContainer.classList.add('is-empty');
            this.wishlistContainer.innerHTML = `
              <div class="page-margin wishlist-content-empty center">
                <span class="wishlist-content-text block">${window.wishlist.empty}</span>
                <div class="wishlist-content-actions">
                  <a class="button" href="${window.routes?.collection_all}">
                    ${window.wishlist.continue_shopping}
                  </a>
                </div>
              </div>
            `;
          }

          if (this.wishlistFooter) this.wishlistFooter.style.display = 'none';
        }
      } else {
        alert('Sorry! No web storage support..');
      }
    }

    setDefaultLayout() {
      const defaultDesktopCol = parseInt(this.dataset.defaultDesktopCol);
      const maxCol = this.getMaxColOnSize();
      const defaultCol = (defaultDesktopCol <= maxCol) ? defaultDesktopCol : maxCol;

      const targetViewCol = this.viewCols.find(viewCol => parseInt(viewCol.dataset.col) === defaultCol );
      if (targetViewCol) {
        targetViewCol.click();
      }
    }

    async setProductForWishlistPage(handle, index, wishlistListLength) {
      try {

        const res = await fetch(`${window.routes.shop_origin}/products/${handle}?view=block_wishlist_card`);
        const data = await res.text();
        const parser = new DOMParser();

        const parsedDoc = parser.parseFromString(data, 'text/html');
        const productHTML = parsedDoc.querySelectorAll('#MainContent .card--block')[0];

        this.gridViewContainer.appendChild(productHTML);
        productHTML.dataset.productHandle = handle;

        this.updateProductForWishlistPage();

        const item = this.wishlistContainer.querySelector(`.card--block[data-product-handle="${handle}"]`);

        if (item != null) {
          item.classList.add('wishlist-added');
          item.querySelector('.text').textContent = window.wishlist.remove;
          item.classList.add('is-in-grid');
          productHTML.dataset.wishlistAdded = `wishlist-${item.dataset.productId}`;
        }

      } catch (err) {
        console.error(err);
      }
    }

    updateProductForWishlistPage() {
      const sectionFetcher = document.querySelector('section-fetcher');

      if (sectionFetcher && typeof sectionFetcher.initialize === 'function') {
        sectionFetcher.initialize();
      } else {
        console.error('WishlistView: No section fetcher component found or initialize method not available');
      }
    }

    wishlistPagination() {
      const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

      this.wishlistPaginateContainer.setAttribute('data-current-page', 1);
      while (this.wishlistPaginateContainer.firstChild) {
        this.wishlistPaginateContainer.removeChild(this.wishlistPaginateContainer.firstChild);
      }

      if (!this.gridViewContainer.classList.contains('productList')) return;
      this.gridViewContainer.classList.remove('is-loaded');

      this.totalPages = Math.ceil(wishlistList.filter(item => item != null).length / 3);

      if (this.totalPages <= 1) {
        [...this.gridViewContainer.children].forEach(child => {
          child.style.display = 'block';
        });
        this.gridViewContainer.classList.add('is-loaded');
        return;
      }

      this.gridViewContainer.classList.add('is-loaded');
    }

    removeItemFromWishlistPage(handle, productId) {
      let productElement = null;

      if (handle) {
        productElement = this.gridViewContainer.querySelector(`[data-product-handle="${handle}"]`);
      }

      if (!productElement && productId) {
        productElement = this.gridViewContainer.querySelector(`[data-wishlist-added="wishlist-${productId}"]`);
      }

      if (productElement) {
        productElement.remove();
      }

      const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
      const remainingItems = this.gridViewContainer.querySelectorAll('[data-product-handle]');

      if (wishlistList.length === 0 || remainingItems.length === 0) {
        if (this.wishlistContainer) {
          this.wishlistContainer.classList.add('is-empty');
          this.wishlistContainer.innerHTML = `
            <div class="page-margin wishlist-content-empty center">
              <span class="wishlist-content-text block">${window.wishlist.empty}</span>
              <div class="wishlist-content-actions">
                <a class="button" href="${window.routes?.collection_all}">
                  ${window.wishlist.continue_shopping}
                </a>
              </div>
            </div>
          `;
        }

        if (this.wishlistFooter) {
          this.wishlistFooter.style.display = 'none';
        }
      } else {
        this.wishlistPagination();
        const updateWishlistMailEvent = new CustomEvent('update:wishlist-mail', {
          bubbles: true
        });
        document.dispatchEvent(updateWishlistMailEvent);

        if (this.gridViewContainer.classList.contains('productList')) {
          const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage) || 1;
          this.paginationForList(true);
        }
      }
    }

    paginateToPages(nextPageNumber = null) {
      const children = [...this.gridViewContainer.children];

      if (nextPageNumber == null) {
        children.forEach((element, index) => {
          if (index >= 3) {
            element.style.display = 'none';
          }
          else {
            element.style.display = 'block';
          }
        });
        return;
      }

      children.forEach((element, index) => {
        if (index >= (nextPageNumber - 1) * 3 && index < nextPageNumber * 3) {
          element.style.display = 'block';
        }
        else {
          element.style.display = 'none';
        }
      });

      if (nextPageNumber === 1) {
        this.wishlistPaginateContainer.querySelector('.prev').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
      else if (nextPageNumber === this.totalPages) {
        this.wishlistPaginateContainer.querySelector('.next').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
      }
      else {
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
    }

    removeAndAddPaginationButtonEvents() {
      const container = this.wishlistPaginateContainer;
      const newContainer = container.cloneNode(true);
      container.parentNode.replaceChild(newContainer, container);
      this.wishlistPaginateContainer = newContainer;

      this.wishlistPaginateContainer.addEventListener('click', (event) => {
        const link = event.target.closest('li a');
        if (!link) return;

        event.preventDefault();
        const li = link.parentElement;
        const isPrev = li.classList.contains('prev');
        const isNext = li.classList.contains('next');
        let pageNumber = parseInt(link.dataset.page);

        const currentButton = this.wishlistPaginateContainer.querySelector('.active');
        let curPage = currentButton ? parseInt(currentButton.querySelector('.link').dataset.page) : 1;

        if (isPrev) {
          pageNumber = curPage - 1;
          if (pageNumber <= 0) pageNumber = 1;
        }

        if (isNext) {
          pageNumber = curPage + 1;
          if (pageNumber > this.totalPages) pageNumber = this.totalPages;
        }

        this.wishlistPaginateContainer.dataset.currentPage = pageNumber;
        this.paginateToPages(pageNumber);

        if (currentButton) {
          currentButton.classList.remove('active');
        }
        const newActive = this.wishlistPaginateContainer.querySelector(`[data-page="${pageNumber}"]`);
        if (newActive && newActive.parentElement) {
          newActive.parentElement.classList.add('active');
        }
      });
    }

    updateShareWishlistViaMail() {
      const regex = /(<([^>]+)>)/ig;
      const addedItems = document.querySelectorAll('[data-wishlist-added]');

      const shareLinkElement = document.querySelector('[data-wishlist-share]');
      let href = 'mailto:?subject= Wish List&body=';

      addedItems.forEach((item, index) => {
        const price = item.querySelector('.price__sale .price__last .price-item')?.textContent || item.querySelector('.price__regular .price__last .price-item')?.textContent;
        const title = item.querySelector('[data-product-title]')?.dataset.productTitle;
        const url = item.querySelector('[data-product-url]')?.dataset.productUrl;

        href += encodeURIComponent(title + '\nPrice: ' + price?.replace(regex, '') + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + url +'\n\n');
      });

      shareLinkElement.href = href;
    }
  }
  if (!customElements.get('wishlist-view')) customElements.define('wishlist-view', WishlistView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-artwork-request"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function init() {
      const root = document.querySelector('.merch-artwork');
      if (!root) return;

      const form = root.querySelector('#ArtworkRequestForm');
      const confirmation = root.querySelector('[data-confirmation]');
      const confirmationEmail = root.querySelector('[data-confirmation-email]');
      const stepCounter = root.querySelector('[data-current-step]');
      const stepMarkers = Array.from(root.querySelectorAll('[data-step-marker]'));
      const stepPanels = Array.from(root.querySelectorAll('.merch-artwork__step'));
      const backBtn = root.querySelector('[data-action="back"]');
      const nextBtn = root.querySelector('[data-action="next"]');
      const submitBtn = root.querySelector('[data-action="submit"]');
      const formErrorBanner = root.querySelector('[data-form-error]');
      const formErrorText = root.querySelector('[data-form-error-text]');
      const phoneInput = form.querySelector('[name="phone"]');
      const dropzone = root.querySelector('[data-dropzone]');
      const fileInput = root.querySelector('.merch-artwork__file-input');
      const fileList = root.querySelector('[data-file-list]');
      const fileError = root.querySelector('[data-error-for="files"]');

      const WEBHOOK_URL = root.dataset.webhookUrl || '';
      const FILES_ENDPOINT = root.dataset.filesEndpoint || '';
      const TOTAL_STEPS = 4;
      const MAX_FILES = 10;
      const MAX_FILE_BYTES = 50 * 1024 * 1024;
      const ALLOWED_EXT = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'svg', 'ai', 'eps', 'psd', 'zip'];

      let currentStep = 1;
      let selectedFiles = [];

      if (phoneInput) {
        phoneInput.addEventListener('input', function(e) {
          let value = e.target.value.replace(/\D/g, '').slice(0, 10);
          let formatted = '';
          if (value.length > 0) formatted = '(' + value.slice(0, 3);
          if (value.length >= 3) formatted += ') ' + value.slice(3, 6);
          if (value.length >= 6) formatted += '-' + value.slice(6, 10);
          e.target.value = formatted;
          clearFieldError(phoneInput);
        });
      }

      function showStep(n) {
        currentStep = Math.max(1, Math.min(TOTAL_STEPS, n));
        stepPanels.forEach(function(panel) {
          panel.classList.toggle('is-active', Number(panel.dataset.step) === currentStep);
        });
        stepMarkers.forEach(function(marker) {
          const stepNum = Number(marker.dataset.stepMarker);
          marker.classList.toggle('is-active', stepNum === currentStep);
          marker.classList.toggle('is-complete', stepNum < currentStep);
        });
        if (stepCounter) stepCounter.textContent = String(currentStep);
        backBtn.disabled = currentStep === 1;
        if (currentStep === TOTAL_STEPS) {
          nextBtn.hidden = true;
          submitBtn.hidden = false;
        } else {
          nextBtn.hidden = false;
          submitBtn.hidden = true;
        }
        const wrapper = root.querySelector('.merch-artwork__form-wrapper');
        if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      backBtn.addEventListener('click', function() {
        hideFormError();
        if (currentStep > 1) showStep(currentStep - 1);
      });

      nextBtn.addEventListener('click', function() {
        hideFormError();
        if (validateStep(currentStep)) showStep(currentStep + 1);
      });

      function setFieldError(field, msg) {
        if (!field) return;
        field.classList.add('is-error');
        const name = field.getAttribute('name') || field.id;
        const errEl = root.querySelector('[data-error-for="' + name + '"]');
        if (errEl) { if (msg) errEl.textContent = msg; errEl.hidden = false; }
      }

      function clearFieldError(field) {
        if (!field) return;
        field.classList.remove('is-error');
        const name = field.getAttribute('name') || field.id;
        const errEl = root.querySelector('[data-error-for="' + name + '"]');
        if (errEl) errEl.hidden = true;
      }

      function showGroupError(name, msg) {
        const errEl = root.querySelector('[data-error-for="' + name + '"]');
        if (errEl) { if (msg) errEl.textContent = msg; errEl.hidden = false; }
      }

      function hideGroupError(name) {
        const errEl = root.querySelector('[data-error-for="' + name + '"]');
        if (errEl) errEl.hidden = true;
      }

      function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      function validateStep(step) {
        const panel = root.querySelector('.merch-artwork__step[data-step="' + step + '"]');
        if (!panel) return true;
        let firstInvalid = null;

        panel.querySelectorAll('[data-validate="required-radio"]').forEach(function(group) {
          const name = group.dataset.fieldName;
          const checked = group.querySelector('input[type="radio"]:checked');
          if (!checked) { showGroupError(name); if (!firstInvalid) firstInvalid = group; }
          else { hideGroupError(name); }
        });

        panel.querySelectorAll('[data-validate="required-checkbox-group"]').forEach(function(group) {
          const name = group.dataset.fieldName;
          const checked = group.querySelectorAll('input[type="checkbox"]:checked');
          if (checked.length === 0) { showGroupError(name); if (!firstInvalid) firstInvalid = group; }
          else { hideGroupError(name); }
        });

        panel.querySelectorAll('[data-validate="required"]').forEach(function(field) {
          if (!field.value.trim()) { setFieldError(field, 'This field is required.'); if (!firstInvalid) firstInvalid = field; }
          else { clearFieldError(field); }
        });

        panel.querySelectorAll('[data-validate="required-min-length"]').forEach(function(field) {
          const min = Number(field.dataset.minLength || 0);
          const val = field.value.trim();
          if (!val) { setFieldError(field, 'This field is required.'); if (!firstInvalid) firstInvalid = field; }
          else if (val.length < min) { setFieldError(field, 'Please give us at least ' + min + ' characters so we can quote accurately.'); if (!firstInvalid) firstInvalid = field; }
          else { clearFieldError(field); }
        });

        panel.querySelectorAll('[data-validate="email"]').forEach(function(field) {
          const val = field.value.trim();
          if (!val) { setFieldError(field, 'Please enter your email address.'); if (!firstInvalid) firstInvalid = field; }
          else if (!isValidEmail(val)) { setFieldError(field, 'Please enter a valid email address.'); if (!firstInvalid) firstInvalid = field; }
          else { clearFieldError(field); }
        });

        panel.querySelectorAll('[data-validate="phone-us"]').forEach(function(field) {
          const digits = field.value.replace(/\D/g, '');
          if (digits.length !== 10) { setFieldError(field, 'Please enter a valid 10-digit phone number.'); if (!firstInvalid) firstInvalid = field; }
          else { clearFieldError(field); }
        });

        if (firstInvalid) {
          const focusable = firstInvalid.matches('input, select, textarea') ? firstInvalid : firstInvalid.querySelector('input, select, textarea');
          if (focusable && typeof focusable.focus === 'function') focusable.focus();
          return false;
        }
        return true;
      }

      form.addEventListener('blur', function(e) {
        const target = e.target;
        if (!target.matches('input, select, textarea')) return;
        const v = target.dataset.validate;
        if (!v) return;
        const val = target.value.trim();
        if (v === 'required' && !val) setFieldError(target, 'This field is required.');
        else if (v === 'required-min-length') {
          const min = Number(target.dataset.minLength || 0);
          if (!val) setFieldError(target, 'This field is required.');
          else if (val.length < min) setFieldError(target, 'Please give us at least ' + min + ' characters so we can quote accurately.');
          else clearFieldError(target);
        } else if (v === 'email') {
          if (val && !isValidEmail(val)) setFieldError(target, 'Please enter a valid email address.');
          else if (!val) setFieldError(target, 'Please enter your email address.');
          else clearFieldError(target);
        } else if (v === 'phone-us') {
          const digits = target.value.replace(/\D/g, '');
          if (digits.length !== 10) setFieldError(target, 'Please enter a valid 10-digit phone number.');
          else clearFieldError(target);
        } else clearFieldError(target);
      }, true);

      form.addEventListener('change', function(e) {
        const target = e.target;
        if (target.matches('input[type="radio"][name="project_type"]')) hideGroupError('project_type');
        if (target.matches('input[type="checkbox"][name="intended_use"]')) hideGroupError('intended_use');
      });

      function fileExt(name) { const i = name.lastIndexOf('.'); return i === -1 ? '' : name.slice(i + 1).toLowerCase(); }
      function formatBytes(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
      }
      function setFileError(msg) { if (!fileError) return; fileError.textContent = msg; fileError.hidden = false; }
      function clearFileError() { if (!fileError) return; fileError.hidden = true; fileError.textContent = ''; }

      function renderFileList() {
        fileList.innerHTML = '';
        selectedFiles.forEach(function(file, idx) {
          const li = document.createElement('li');
          li.className = 'merch-artwork__file-item';
          li.innerHTML =
            '<span class="merch-artwork__file-icon" aria-hidden="true">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
                '<polyline points="14 2 14 8 20 8"/>' +
              '</svg>' +
            '</span>' +
            '<span class="merch-artwork__file-meta">' +
              '<span class="merch-artwork__file-name"></span>' +
              '<span class="merch-artwork__file-size"></span>' +
            '</span>' +
            '<button type="button" class="merch-artwork__file-remove" aria-label="Remove file">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="18" y1="6" x2="6" y2="18"/>' +
                '<line x1="6" y1="6" x2="18" y2="18"/>' +
              '</svg>' +
            '</button>';
          li.querySelector('.merch-artwork__file-name').textContent = file.name;
          li.querySelector('.merch-artwork__file-size').textContent = formatBytes(file.size);
          li.querySelector('.merch-artwork__file-remove').addEventListener('click', function() {
            selectedFiles.splice(idx, 1);
            renderFileList();
          });
          fileList.appendChild(li);
        });
      }

      function addFiles(filesToAdd) {
        clearFileError();
        const incoming = Array.from(filesToAdd);
        for (let i = 0; i < incoming.length; i++) {
          const f = incoming[i];
          const ext = fileExt(f.name);
          if (ALLOWED_EXT.indexOf(ext) === -1) { setFileError('"' + f.name + '" is not an allowed file type.'); continue; }
          if (f.size > MAX_FILE_BYTES) { setFileError('"' + f.name + '" is over the 50MB limit.'); continue; }
          if (selectedFiles.length >= MAX_FILES) { setFileError('You can upload up to ' + MAX_FILES + ' files. Remove a file to add more.'); break; }
          const dup = selectedFiles.some(function(existing) { return existing.name === f.name && existing.size === f.size; });
          if (!dup) selectedFiles.push(f);
        }
        renderFileList();
        fileInput.value = '';
      }

      fileInput.addEventListener('change', function(e) { if (e.target.files && e.target.files.length) addFiles(e.target.files); });
      ['dragenter', 'dragover'].forEach(function(evt) { dropzone.addEventListener(evt, function(e) { e.preventDefault(); e.stopPropagation(); dropzone.classList.add('is-dragover'); }); });
      ['dragleave', 'drop'].forEach(function(evt) { dropzone.addEventListener(evt, function(e) { e.preventDefault(); e.stopPropagation(); dropzone.classList.remove('is-dragover'); }); });
      dropzone.addEventListener('drop', function(e) { if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) addFiles(e.dataTransfer.files); });

      function showFormError(msg) { if (!formErrorBanner) return; if (msg && formErrorText) formErrorText.innerHTML = msg; formErrorBanner.hidden = false; }
      function hideFormError() { if (formErrorBanner) formErrorBanner.hidden = true; }

      function collectPayload() {
        const fd = new FormData(form);
        const intendedUse = fd.getAll('intended_use').join(', ');
        return {
          firstName: fd.get('first_name') || '',
          lastName: fd.get('last_name') || '',
          email: fd.get('email') || '',
          phone: fd.get('phone') || '',
          companyName: fd.get('company_name') || '',
          source: 'Artwork Request Form',
          customFields: {
            project_type: fd.get('project_type') || '',
            intended_use: intendedUse,
            estimated_order_size: fd.get('estimated_order_size') || '',
            project_description: fd.get('project_description') || '',
            inspiration_references: fd.get('inspiration_references') || '',
            deadline_date: fd.get('deadline_date') || null,
            how_heard: fd.get('how_heard') || '',
            submission_timestamp: new Date().toISOString()
          },
          tags: ['Artwork Request', 'Website Lead']
        };
      }

      function uploadOneFile(email, file) {
        const fd = new FormData();
        fd.append('email', email);
        fd.append('file', file, file.name);
        return fetch(FILES_ENDPOINT, { method: 'POST', body: fd })
          .then(function(res) {
            if (res.ok) return { name: file.name, ok: true };
            return res.text().catch(function() { return ''; }).then(function(detail) {
              return { name: file.name, ok: false, status: res.status, detail: detail.slice(0, 200) };
            });
          })
          .catch(function(err) { return { name: file.name, ok: false, error: String(err && err.message || err) }; });
      }

      function uploadFiles(email) {
        if (!FILES_ENDPOINT || selectedFiles.length === 0) return Promise.resolve({ skipped: true });
        const jobs = selectedFiles.map(function(f) { return uploadOneFile(email, f); });
        return Promise.all(jobs).then(function(results) {
          const failed = results.filter(function(r) { return !r.ok; });
          if (failed.length > 0) console.error('[Artwork Request] File upload(s) failed:', failed);
          return { results: results, failedCount: failed.length, total: results.length };
        });
      }

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        hideFormError();
        let allValid = true;
        for (let s = 1; s <= TOTAL_STEPS; s++) {
          if (!validateStep(s)) { allValid = false; showStep(s); break; }
        }
        if (!allValid) return;
        if (!WEBHOOK_URL) {
          showFormError('This form is not fully configured yet. Please email <a href="mailto:artwork@merchunlimited.com">artwork@merchunlimited.com</a>.');
          return;
        }
        const payload = collectPayload();
        const emailValue = payload.email;
        submitBtn.disabled = true;
        const btnTextEl = submitBtn.querySelector('.merch-artwork__btn-text');
        const previousText = btnTextEl ? btnTextEl.textContent : 'Submit Request';
        if (btnTextEl) btnTextEl.textContent = 'Submitting...';
        fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Webhook returned ' + res.status);
          return uploadFiles(emailValue).catch(function(err) {
            console.error('[Artwork Request] File upload failed:', err, { email: emailValue, timestamp: new Date().toISOString() });
            return { fileUploadFailed: true };
          });
        })
        .then(function() {
          if (confirmationEmail) confirmationEmail.textContent = emailValue;
          form.hidden = true;
          const progress = root.querySelector('.merch-artwork__progress');
          if (progress) progress.hidden = true;
          if (confirmation) confirmation.hidden = false;
          window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
        })
        .catch(function(err) {
          console.error('[Artwork Request] Submission failed:', err, { timestamp: new Date().toISOString() });
          submitBtn.disabled = false;
          if (btnTextEl) btnTextEl.textContent = previousText;
          showFormError('We couldn&rsquo;t submit your request right now. Please try again or email <a href="mailto:artwork@merchunlimited.com">artwork@merchunlimited.com</a>.');
        });
      });

      showStep(1);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.merch-contact__form');
    if (!form) return;

    const phoneInput = document.getElementById('ContactPhone');
    const serviceCheckboxes = form.querySelectorAll('.merch-contact__pill-input');
    const pillsContainer = form.querySelector('.merch-contact__pills');
    const submitButton = form.querySelector('.merch-contact__submit');
    const servicesHiddenInput = document.getElementById('ContactServices');
    const smsOptinCheckbox = document.getElementById('ContactSmsOptin');
    const smsOptinField = smsOptinCheckbox?.closest('.merch-contact__field--checkbox');

    // Function to update hidden services field
    function updateServicesField() {
      const selectedServices = Array.from(serviceCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.getAttribute('data-service-label'))
        .join(', ');
      if (servicesHiddenInput) {
        servicesHiddenInput.value = selectedServices;
      }
    }

    // Update hidden field when checkboxes change
    serviceCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', updateServicesField);
    });

    // Auto-format phone number as user types
    if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
        let formatted = '';
        if (value.length > 0) {
          formatted = '(' + value.slice(0, 3);
        }
        if (value.length >= 3) {
          formatted += ') ' + value.slice(3, 6);
        }
        if (value.length >= 6) {
          formatted += '-' + value.slice(6, 10);
        }
        e.target.value = formatted;
        phoneInput.setCustomValidity('');
      });
    }

    // Remove error state when a service is selected (already have change listener above for updateServicesField)
    serviceCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        pillsContainer.classList.remove('merch-contact__pills--error');
      });
    });

    // Remove error state when SMS opt-in is checked
    if (smsOptinCheckbox && smsOptinField) {
      smsOptinCheckbox.addEventListener('change', function() {
        smsOptinField.classList.remove('merch-contact__field--error');
      });
    }

    // Intercept submit button click
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        // Update hidden services field before validation
        updateServicesField();

        let isValid = true;
        let firstError = null;

        // Validate phone number
        if (phoneInput) {
          const digits = phoneInput.value.replace(/\D/g, '');
          if (digits.length !== 10) {
            isValid = false;
            phoneInput.setCustomValidity('Please enter a valid 10-digit phone number');
            if (!firstError) firstError = 'phone';
          } else {
            phoneInput.setCustomValidity('');
          }
        }

        // Validate at least one service selected
        const hasServiceSelected = Array.from(serviceCheckboxes).some(cb => cb.checked);
        if (!hasServiceSelected) {
          isValid = false;
          pillsContainer.classList.add('merch-contact__pills--error');
          if (!firstError) firstError = 'service';
        }

        // Validate SMS opt-in is checked
        if (smsOptinCheckbox && !smsOptinCheckbox.checked) {
          isValid = false;
          if (smsOptinField) smsOptinField.classList.add('merch-contact__field--error');
          if (!firstError) firstError = 'sms';
        } else if (smsOptinField) {
          smsOptinField.classList.remove('merch-contact__field--error');
        }

        // If not valid, prevent submission
        if (!isValid) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if (firstError === 'phone') {
            phoneInput.reportValidity();
            phoneInput.focus();
          } else if (firstError === 'service') {
            alert('Please select at least one service you are interested in.');
            pillsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (firstError === 'sms') {
            alert('Please agree to receive SMS text messages to continue.');
            smsOptinCheckbox.focus();
          }
          return false;
        }
      });
    }

    // Also intercept form submit as backup and send to webhook
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Update hidden services field
      updateServicesField();

      const hasServiceSelected = Array.from(serviceCheckboxes).some(cb => cb.checked);
      const digits = phoneInput ? phoneInput.value.replace(/\D/g, '') : '';
      const smsOptinChecked = smsOptinCheckbox ? smsOptinCheckbox.checked : true;

      // Validate
      if (!hasServiceSelected || (phoneInput && digits.length !== 10) || !smsOptinChecked) {
        if (!hasServiceSelected) {
          pillsContainer.classList.add('merch-contact__pills--error');
          alert('Please select at least one service you are interested in.');
          pillsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (phoneInput && digits.length !== 10) {
          phoneInput.setCustomValidity('Please enter a valid 10-digit phone number');
          phoneInput.reportValidity();
          phoneInput.focus();
        } else if (!smsOptinChecked) {
          if (smsOptinField) smsOptinField.classList.add('merch-contact__field--error');
          alert('Please agree to receive SMS text messages to continue.');
          smsOptinCheckbox.focus();
        }
        return false;
      }

      // Verify Turnstile was completed
      var qsToken = (form.querySelector('[name="cf-turnstile-response"]') || {}).value || '';
      var contactError = document.getElementById('ContactError');
      if (!qsToken) {
        if (contactError) { contactError.textContent = 'Please complete the verification below, then submit again.'; contactError.style.display = 'block'; }
        return false;
      }
      if (contactError) contactError.style.display = 'none';

      // Collect form data - services as array for GHL multi-select field
      // Uses the value attribute (not label) for webhook mapping
      const selectedServicesArray = Array.from(serviceCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);

      const formData = {
        first_name: form.querySelector('[name="contact[first_name]"]')?.value || '',
        last_name: form.querySelector('[name="contact[last_name]"]')?.value || '',
        email: form.querySelector('[name="contact[email]"]')?.value || '',
        phone: phoneInput?.value || '',
        'service_requested': selectedServicesArray,
        'sms_optin': smsOptinCheckbox?.checked ? 'Yes' : 'No',
        'website_url': form.querySelector('[name="website_url"]')?.value || '',
        'turnstile_token': qsToken
      };

      // Disable submit button
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.querySelector('.merch-contact__submit-text').textContent = 'Sending...';
      }

      // Send to the mu-support Worker (verifies Turnstile + forwards to GHL; webhook stays server-side)
      fetch('https://mu-support.merchunlimited.workers.dev/quote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        if (response.ok) {
          // Show success message
          form.innerHTML = '<div class="merch-contact__success"><svg class="merch-contact__success-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><p class="merch-contact__success-text">Thank you! We\'ll get back to you within 1 hour.</p></div>';
        } else {
          throw new Error('Network response was not ok');
        }
      })
      .catch(function(error) {
        console.error('Error:', error);
        if (contactError) {
          contactError.textContent = 'There was an error submitting the form. Please complete the verification and try again.';
          contactError.style.display = 'block';
        }
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.querySelector('.merch-contact__submit-text').textContent = 'Send Message';
        }
        if (window.turnstile) { window.turnstile.reset(); }
      });

      return false;
    }, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-dtf-product"] && !Shopify.designMode) return;
  try {
    
  // Digital Rain Effect for DTF Product Page
  document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.getElementById('dtf-matrix-rain');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const chars = 'DTFGANGSHEETTRANSFER01'.split('');
    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = Array(columns).fill(1);

    function draw() {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#00ffff';
      ctx.font = fontSize + 'px monospace';

      for (let i = 0; i < drops.length; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        ctx.fillText(char, i * fontSize, drops[i] * fontSize);

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    }

    setInterval(draw, 50);
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-giveaway-ninja"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('GiveawayNinjaForm');
    if (!form) return;

    var submitButton = form.querySelector('.merch-gn__submit');
    var submitText = form.querySelector('.merch-gn__submit-text');
    var submitDefault = submitText ? submitText.textContent : 'Send it';
    var formContent = form.querySelector('.merch-gn__form-content');
    var successBlock = form.querySelector('.merch-gn__success');
    var formError = document.getElementById('GnFormError');
    var phoneInput = document.getElementById('GnPhone');

    function showFieldError(input, message) {
      var describedBy = (input.getAttribute('aria-describedby') || '').split(' ');
      var errorEl = null;
      describedBy.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.classList.contains('merch-gn__error-text')) errorEl = el;
      });
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      input.classList.add('merch-gn__input--error');
      input.setAttribute('aria-invalid', 'true');
    }

    function clearFieldError(input) {
      var describedBy = (input.getAttribute('aria-describedby') || '').split(' ');
      describedBy.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.classList.contains('merch-gn__error-text')) { el.textContent = ''; el.hidden = true; }
      });
      input.classList.remove('merch-gn__input--error');
      input.removeAttribute('aria-invalid');
    }

    function showGroupError(fieldset, errorId, message) {
      var errorEl = document.getElementById(errorId);
      if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
      if (fieldset) fieldset.classList.add('merch-gn__fieldset--error');
    }

    function clearGroupError(fieldset, errorId) {
      var errorEl = document.getElementById(errorId);
      if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
      if (fieldset) fieldset.classList.remove('merch-gn__fieldset--error');
    }

    // Reflect radio/checkbox selection on the option card (robust highlight without :has)
    form.querySelectorAll('.merch-gn__option-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.type === 'radio') {
          form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (sib) {
            var opt = sib.closest('.merch-gn__option');
            if (opt) opt.classList.toggle('is-selected', sib.checked);
          });
        } else {
          var opt = input.closest('.merch-gn__option');
          if (opt) opt.classList.toggle('is-selected', input.checked);
        }
        var fs = input.closest('.merch-gn__fieldset');
        if (fs) {
          var err = fs.querySelector('.merch-gn__error-text');
          if (err) clearGroupError(fs, err.id);
        }
      });
    });

    // Clear inline errors as the user fixes text fields
    ['GnName', 'GnEmail', 'GnPhone', 'GnBrand', 'GnWebsite', 'GnPrize'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { clearFieldError(el); });
    });

    // Phone auto-format (only when the user enters something; the field is optional)
    if (phoneInput) {
      phoneInput.addEventListener('input', function (e) {
        var value = e.target.value.replace(/\D/g, '').slice(0, 10);
        var formatted = '';
        if (value.length > 0) formatted = '(' + value.slice(0, 3);
        if (value.length >= 3) formatted += ') ' + value.slice(3, 6);
        if (value.length >= 6) formatted += '-' + value.slice(6, 10);
        e.target.value = formatted;
      });
    }

    function normalizeUrl(value) {
      var v = value.trim();
      if (v === '') return v;
      if (!/^https?:\/\//i.test(v)) v = 'https://' + v;
      return v;
    }

    function validate() {
      var firstInvalid = null;

      // Required text-style fields
      [
        { id: 'GnName', label: 'Your name' },
        { id: 'GnBrand', label: 'Channel or brand name' },
        { id: 'GnPrize', label: 'This field' }
      ].forEach(function (f) {
        var el = document.getElementById(f.id);
        if (!el) return;
        if (el.value.trim() === '') {
          showFieldError(el, f.label + ' is required.');
          if (!firstInvalid) firstInvalid = el;
        } else {
          clearFieldError(el);
        }
      });

      // Email
      var email = document.getElementById('GnEmail');
      if (email) {
        if (email.value.trim() === '') {
          showFieldError(email, 'Email is required.');
          if (!firstInvalid) firstInvalid = email;
        } else if (!email.checkValidity()) {
          showFieldError(email, 'Enter a valid email address.');
          if (!firstInvalid) firstInvalid = email;
        } else {
          clearFieldError(email);
        }
      }

      // Website (required, normalize then validate)
      var website = document.getElementById('GnWebsite');
      if (website) {
        if (website.value.trim() === '') {
          showFieldError(website, 'A link is required so we can check you out.');
          if (!firstInvalid) firstInvalid = website;
        } else {
          website.value = normalizeUrl(website.value);
          if (!website.checkValidity()) {
            showFieldError(website, 'Enter a valid link, like youtube.com/yourchannel.');
            if (!firstInvalid) firstInvalid = website;
          } else {
            clearFieldError(website);
          }
        }
      }

      // Phone (optional; validate only if provided)
      if (phoneInput && phoneInput.value.trim() !== '') {
        var digits = phoneInput.value.replace(/\D/g, '');
        if (digits.length !== 10) {
          showFieldError(phoneInput, 'Enter a 10 digit phone number, or leave it blank.');
          if (!firstInvalid) firstInvalid = phoneInput;
        } else {
          clearFieldError(phoneInput);
        }
      }

      // Required radio groups
      [
        { name: 'audience_size', errorId: 'GnAudience-error' },
        { name: 'using_giveaway_ninja', errorId: 'GnUsing-error' },
        { name: 'prize_value', errorId: 'GnValue-error' },
        { name: 'launch_timeline', errorId: 'GnTimeline-error' }
      ].forEach(function (g) {
        var checked = form.querySelector('input[name="' + g.name + '"]:checked');
        var fieldset = form.querySelector('input[name="' + g.name + '"]').closest('.merch-gn__fieldset');
        if (!checked) {
          showGroupError(fieldset, g.errorId, 'Pick one option.');
          if (!firstInvalid) firstInvalid = form.querySelector('input[name="' + g.name + '"]');
        } else {
          clearGroupError(fieldset, g.errorId);
        }
      });

      // Required checkbox group (at least one)
      var helpChecked = form.querySelectorAll('input[name="help_with"]:checked');
      var helpFieldset = form.querySelector('input[name="help_with"]').closest('.merch-gn__fieldset');
      if (helpChecked.length === 0) {
        showGroupError(helpFieldset, 'GnHelp-error', 'Select at least one.');
        if (!firstInvalid) firstInvalid = form.querySelector('input[name="help_with"]');
      } else {
        clearGroupError(helpFieldset, 'GnHelp-error');
      }

      return firstInvalid;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (formError) { formError.hidden = true; formError.textContent = ''; }

      var firstInvalid = validate();
      if (firstInvalid) {
        if (typeof firstInvalid.focus === 'function') firstInvalid.focus();
        if (typeof firstInvalid.scrollIntoView === 'function') {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }

      // Turnstile token
      var tsField = form.querySelector('[name="cf-turnstile-response"]');
      var tsToken = tsField ? tsField.value : '';
      if (!tsToken) {
        if (formError) { formError.textContent = 'Please complete the verification below, then submit again.'; formError.hidden = false; }
        return false;
      }

      // Collect help_with as a readable comma joined string
      var helpValues = [];
      form.querySelectorAll('input[name="help_with"]:checked').forEach(function (cb) { helpValues.push(cb.value); });

      function rv(name) {
        var el = form.querySelector('input[name="' + name + '"]:checked');
        return el ? el.value : '';
      }
      function fv(name) {
        var el = form.querySelector('[name="' + name + '"]');
        return el ? el.value.trim() : '';
      }

      // Split the single "Your name" field into first/last for GHL's native name fields.
      var nameParts = fv('name').split(/\s+/).filter(function (p) { return p; });
      var firstName = nameParts.length === 1 ? nameParts[0] : nameParts.slice(0, -1).join(' ');
      var lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '';

      var payload = {
        name: fv('name'),
        first_name: firstName,
        last_name: lastName,
        email: fv('email'),
        phone: fv('phone'),
        brand_name: fv('brand_name'),
        website_link: fv('website_link'),
        audience_size: rv('audience_size'),
        using_giveaway_ninja: rv('using_giveaway_ninja'),
        prize_description: fv('prize_description'),
        prize_value: rv('prize_value'),
        launch_timeline: rv('launch_timeline'),
        help_with: helpValues.join(', '),
        budget: rv('budget'),
        additional_info: fv('additional_info'),
        sms_consent: (form.querySelector('[name="sms_consent"]') && form.querySelector('[name="sms_consent"]').checked) ? 'Yes' : 'No',
        source: 'giveaway-ninja-landing-page',
        website_url: fv('website_url'),
        turnstile_token: tsToken
      };

      if (submitButton) {
        submitButton.disabled = true;
        if (submitText) submitText.textContent = 'Sending...';
      }

      fetch('https://mu-support.merchunlimited.workers.dev/giveaway', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok && result.data && result.data.ok) {
            if (formContent) formContent.style.display = 'none';
            if (successBlock) successBlock.hidden = false;
            if (successBlock && typeof successBlock.scrollIntoView === 'function') {
              successBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          } else {
            if (formError) {
              formError.textContent = (result.data && result.data.error) || 'Something went wrong sending your info. Please try again.';
              formError.hidden = false;
            }
            if (submitButton) { submitButton.disabled = false; if (submitText) submitText.textContent = submitDefault; }
            if (window.turnstile) window.turnstile.reset();
          }
        })
        .catch(function (error) {
          console.error('Giveaway Ninja form error:', error);
          if (formError) { formError.textContent = 'Network error. Please try again.'; formError.hidden = false; }
          if (submitButton) { submitButton.disabled = false; if (submitText) submitText.textContent = submitDefault; }
          if (window.turnstile) window.turnstile.reset();
        });

      return false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-rolling-dtf-product"] && !Shopify.designMode) return;
  try {
    
  // Digital Rain Effect for Rolling DTF Product Page
  document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.getElementById('rolling-dtf-matrix-rain');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const chars = 'ROLLINGGANGSHEET01$%'.split('');
    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = Array(columns).fill(1);

    function draw() {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#00ffff';
      ctx.font = fontSize + 'px monospace';

      for (let i = 0; i < drops.length; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        ctx.fillText(char, i * fontSize, drops[i] * fontSize);

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    }

    setInterval(draw, 50);
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#rolling-gang-sheet-builder"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-support"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('SupportForm');
    if (!form) return;

    const phoneInput = document.getElementById('SupportPhone');
    const submitButton = form.querySelector('.merch-support__submit');
    const formContent = form.querySelector('.merch-support__form-content');
    const successMessage = form.querySelector('.merch-support__success');
    const smsOptinCheckbox = document.getElementById('SupportSmsOptin');
    const smsOptinField = smsOptinCheckbox?.closest('.merch-support__field--checkbox');

    // Auto-format phone number as user types
    if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
        let formatted = '';
        if (value.length > 0) {
          formatted = '(' + value.slice(0, 3);
        }
        if (value.length >= 3) {
          formatted += ') ' + value.slice(3, 6);
        }
        if (value.length >= 6) {
          formatted += '-' + value.slice(6, 10);
        }
        e.target.value = formatted;
        phoneInput.setCustomValidity('');
      });
    }

    // Remove error state when SMS opt-in is checked
    if (smsOptinCheckbox && smsOptinField) {
      smsOptinCheckbox.addEventListener('change', function() {
        smsOptinField.classList.remove('merch-support__field--error');
      });
    }

    // Form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Validate phone number
      if (phoneInput) {
        const digits = phoneInput.value.replace(/\D/g, '');
        if (digits.length !== 10) {
          phoneInput.setCustomValidity('Please enter a valid 10-digit phone number');
          phoneInput.reportValidity();
          phoneInput.focus();
          return false;
        }
      }

      // Validate SMS opt-in is checked
      if (smsOptinCheckbox && !smsOptinCheckbox.checked) {
        if (smsOptinField) smsOptinField.classList.add('merch-support__field--error');
        alert('Please agree to receive SMS text messages to continue.');
        smsOptinCheckbox.focus();
        return false;
      }

      // Verify Turnstile was completed
      var tsToken = (form.querySelector('[name="cf-turnstile-response"]') || {}).value || '';
      var supportError = document.getElementById('SupportError');
      if (!tsToken) {
        if (supportError) { supportError.textContent = 'Please complete the verification below, then submit again.'; supportError.style.display = 'block'; }
        return false;
      }
      if (supportError) supportError.style.display = 'none';

      // Collect form data
      const formData = {
        first_name: form.querySelector('[name="first_name"]')?.value || '',
        last_name: form.querySelector('[name="last_name"]')?.value || '',
        email: form.querySelector('[name="email"]')?.value || '',
        phone: phoneInput?.value || '',
        order_number: form.querySelector('[name="order_number"]')?.value || '',
        inquiry_type: form.querySelector('[name="inquiry_type"]')?.value || '',
        message: form.querySelector('[name="message"]')?.value || '',
        sms_optin: form.querySelector('[name="sms_optin"]')?.checked ? 'Yes' : 'No',
        source: 'Contact Page - Customer Support',
        website_url: form.querySelector('[name="website_url"]')?.value || '',
        turnstile_token: tsToken
      };

      // Disable submit button
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.querySelector('.merch-support__submit-text').textContent = 'Sending...';
      }

      // Send to the mu-support Worker (verifies Turnstile + forwards to GHL; webhook stays server-side)
      fetch('https://mu-support.merchunlimited.workers.dev/support', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function(result) {
        if (result.ok && result.data && result.data.ok) {
          if (formContent) formContent.style.display = 'none';
          if (successMessage) successMessage.style.display = 'flex';
        } else {
          if (supportError) {
            supportError.textContent = (result.data && result.data.error) || 'There was an error submitting the form. Please try again.';
            supportError.style.display = 'block';
          }
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.querySelector('.merch-support__submit-text').textContent = 'Send Message';
          }
          if (window.turnstile) { window.turnstile.reset(); }
        }
      })
      .catch(function(error) {
        console.error('Error:', error);
        if (supportError) {
          supportError.textContent = 'Network error. Please try again.';
          supportError.style.display = 'block';
        }
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.querySelector('.merch-support__submit-text').textContent = 'Send Message';
        }
        if (window.turnstile) { window.turnstile.reset(); }
      });

      return false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
